import axiosInstance from "@/api/base/axiosInstance";

export const useConnectionYear = {
  data: () => ({
    interceptorId: null,
  }),
  methods: {
    setUseConnectionHeaderYear(year) {
      if( this.interceptorId !== null ) {
        axiosInstance.interceptors.request.eject(this.interceptorId);
        this.interceptorId = null;
      }
      this.interceptorId = axiosInstance.interceptors.request.use(config => {
        config.headers['use-connection-year'] = year;
        return config;
      });
    },
    removeUseConnectionHeaderYear() {
      if (this.interceptorId !== null) {
        axiosInstance.interceptors.request.eject(this.interceptorId);
      }
    }
  }
}